<template>
  <div>
    <TableFilters
      :filters="['product', 'toShop', 'fromShop', 'dateRange']"
      :columns="columns"
      @updateColumnsTable="updateColumnsTable"
      v-model="filter"
      :export="[`productexport`]"
    ></TableFilters>
    <v-row class="py-0 my-0">
      <v-col cols="12" md="12" lg="7" class="pa-5">
        <v-btn-toggle v-model="toggle_exclusive">
          <v-btn
            @click="
              goto('indextable');
              viewpdfFile();
            "
          >
            View Report
          </v-btn>
          <v-btn @click="exportPDF()"> Generate PDF </v-btn>
          <v-btn @click="exceldownload()"> Generate CSV </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-card class="mt-2" v-show="false">
      <v-container fluid>
        <v-row>
          <v-card-text class="pa-0">
            <v-data-table
              :items-per-page="1000"
              :fixed-header="true"
              :headers="headers"
              :items="shoptoshop"
              item-key="id"
              style="margin-top: 100"
              class="row-pointer product-list"
              id="indextable41"
            >
              <template v-slot:no-data>
                <div class="mt-16 container justify-center item-center">
                  <noData name="Product Transfer" />
                </div>
              </template>

              <template v-slot:item.reference_number="{ item }">{{
                item.reference_number ? item.reference_number : '.......'
              }}</template>

              <template v-slot:item.date="{ item }">{{
                item.date | formatDate
              }}</template>

              <template v-slot:item.fromShop="{ item }">{{
                item.fromShop ? item.fromShop.name : '.......'
              }}</template>

              <template v-slot:item.toShop="{ item }">{{
                item.toShop ? item.toShop.name : '.......'
              }}</template>

              <template v-slot:item.product="{ item }">{{
                item.shopTransferItems[0].product
                  ? item.shopTransferItems[0].product.name
                  : '.......'
              }}</template>

              <template v-slot:item.quantity="{ item }">{{
                item.shopTransferItems[0].quantity
              }}</template>

              <template v-slot:item.status="{ item }">{{
                item.status ? item.status : '.......'
              }}</template>
            </v-data-table>
          </v-card-text>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import PageTitle from '@/components/shared/PageTitle';
import TableFilters from '@/components/base/TableFilters';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import XLSX from 'xlsx';
import { DateTime } from '@grapecity/wijmo';
import moment from 'moment';
import _ from 'lodash';
import { mapState } from 'vuex';
export default {
  data: () => ({
    columns: [
      {
        text: 'No',
        value: 'no',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => (item?.no ? item?.no : null),
      },

      {
        text: 'Reference Number',
        value: 'reference_number',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) =>
          item?.reference_number ? item?.reference_number : null,
      },
      {
        text: 'Date',
        value: 'date',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) =>
          item?.date ? moment(item?.date).format('YYYY-MM-DD') : null,
      },

      {
        text: 'From Shop ',
        value: 'fromShop',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => (item?.fromShop ? item?.fromShop?.name : null),
      },

      {
        text: 'To Shop ',
        value: 'toShop',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => (item?.toShop ? item?.toShop.name : null),
      },

      {
        text: 'Product',
        value: 'product',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) =>
          item?.shopTransferItems[0].product
            ? item?.shopTransferItems[0].product.name
            : null,
      },

      {
        text: 'Quantity',
        value: 'quantity',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) =>
          item?.shopTransferItems[0].quantity
            ? item?.shopTransferItems[0].quantity
            : null,
      },
      {
        text: 'Transfer Status',
        value: 'status',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => (item?.status ? item?.status : null),
      },
    ],
    shoptoshop: [],
    hide: '',
    // Filters
    filter: {
      category: '',
      search: '',
      brand: '',
      status: '',
    },
  }),
  components: {
    PageTitle,
    TableFilters,
  },

  methods: {
    updateColumnsTable() {
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);
      setTimeout(() => {
        this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
      }, 100);
    },
    generateReport(callBack = () => {}) {
      this.$store.commit('UPDATE_PDF_VISIBLE', true);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);

      var filter = this.filter;
      this.$store
        .dispatch('report/getShopToShopTransferReportProductManagement', filter)
        .then((res) => {
          let i = 1;
          this.shoptoshop = res.data.data;
          this.shoptoshop.map((p) => {
            p.no = i;
            i++;
          });
          setTimeout(() => {
            // Update Pdf To List
            callBack();
            this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
            // Update Pdf To List Datas
            this.$store.commit('UPDATE_PDF_DATAS', this.shoptoshop);
            // Update Pdf To List_Title
            this.$store.commit(
              'UPDATE_PDF_TITLE',
              'Shop to Shop Transfer Report Product Management',
            );
            this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
            callBack();
          }, 100);
        })
        .catch((err) => {
          this.isLoading = false;
          this.$store.commit('UPDATE_PDF_VISIBLE', false);
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);

          this.messages = err.data.title;
        });
    },
    async viewpdfFile() {
      await this.generateReport();
      setTimeout(() => {
        if (this.shoptoshop.length > 0) {
          this.$store.commit('UPDATE_PDF_VISIBLE', true);
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
        }
      }, 400);
    },

    exportPDF() {
      const printPdf = () => {
        let Data = _.cloneDeep(this.shoptoshop);
        for (let x = 0; x < Data.length; x++) {
          Data[x].date = moment(Data[x].date, 'YYYY-MM-DD').format(
            'DD/MM/YYYY',
          );
          Data[x].reference_number = Data[x].reference_number;
          Data[x].fromShop = Data[x].fromShop.name;
          Data[x].toShop = Data[x].toShop.name;
          Data[x].quantity = Data[x].shopTransferItems[0].quantity;
          Data[x].product = Data[x].shopTransferItems[0].product.name;
          Data[x].status = Data[x].status;
        }
        var rows = Data;
        var doc = jsPDF({
          orientation: 'landscape',
        });
        doc.setFontSize(13);
        // doc.setFontType("bold");
        doc.setTextColor(26, 26, 26);
        doc.setFont('helvetica', 'normal');
        doc.text('Shop to Shop Transfer Report', 15, 5);

        doc.setFontSize(9);
        doc.text(
          246,
          5,
          `Generated Date and Time  -  ${moment(today).format(
            'DD-MM-YYYY HH:MM:SS',
          )}`,
          'center',
        );

        doc.setFontSize(9);

        // let height;
        // if (this.filterDatas.shopquery == "" && this.filterDatas.productquery == "") {
        //   height = 15;
        // }  else {
        //   height = 30;
        // }

        const conditions = [
          { key: 'productquery', label: 'Product' },
          { key: 'toShopquery', label: 'To Shop' },
          { key: 'fromShopquery', label: 'From Shop' },
        ];
        // Function to get text based on filter data
        const getText = (key, label, value) => {
          return value ? `${label} - ${value}` : '';
        };
        // Iterate over conditions and build the text
        let height = conditions.reduce((acc, condition) => {
          const value = this.filterDatas[condition.key];
          const text = getText(condition.key, condition.label, value);
          if (text) {
            doc.text(text, 15, acc);
            return acc + 5; // Increment
          }
          return acc;
        }, 12); // Initial
        // Add Date Range if both start and end are available
        if (this.filterDatas.start && this.filterDatas.end) {
          const dateRangeText = `Date Range - ${this.filterDatas.start} - ${this.filterDatas.end}`;
          doc.text(dateRangeText, 15, height);
          height += 5; // Increment
        }
        // Set a default height if no conditions matched
        height = height || 20;

        doc.autoTable(
          this.headers.map((h) => {
            return { title: h.text, dataKey: h.value };
          }),
          rows,
          {
            didParseCell: function (data) {
              if (data.column.dataKey === 'addsress') {
                data.cell.text = data.cell.raw.country;
              }
            },
            startY: height,
          },
        );
        const today = new DateTime();
        doc.save(
          `${moment(today).format(
            'DD-MM-YYYY',
          )}-Shop to Shop Product Transfer Report.pdf`,
        );
      };
      this.generateReport(printPdf);
    },
    //Product Details Export Excel
    exceldownload() {
      const printExcel = () => {
        var data = document.getElementById('indextable41');
        const today = new DateTime();
        const headData = XLSX.utils.table_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          wb,
          headData,
          moment(today).format('DD-MM-YYYY'),
        );
        XLSX.writeFile(
          wb,
          `${moment(today).format(
            'DD-MM-YYYY',
          )}-Shop to Shop Product Transfer Report.xlsx`,
        );
      };
      this.generateReport(printExcel);
    },
    goto(id) {
      var element = document.getElementById(id);
      element.scrollIntoView({ behavior: 'smooth' });
    },
  },
  computed: {
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },

    ...mapState(['filterDatas']),
  },
  created() {
    this.$store.commit('UPDATE_PDF_VISIBLE', false);
    this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
  },
};
</script>
<style>
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) {
  border-radius: 6px;
}
.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 31px;
}
</style>
